export default "__VITE_ASSET__Bcv7m_qZ__"